import React, { useState, useEffect } from "react";
import { useSessionStorage } from "../storage/useSessionStorage";
import { UsuarioContext } from "./UsuarioContext";

const UsuarioState = (props) => {
    const [usuario, setUsuario] = useSessionStorage("usuario_almacenado", null);
    const [token, setToken] = useSessionStorage("toke_almacenado", null);
    const [invernaderoSeleccionado, setInvernaderoSeleccionadoSession] = useSessionStorage("invernadero_almacenado", null);

    const setInvernaderoSeleccionado = (invernadero) => {
        setInvernaderoSeleccionadoSession(invernadero);
    };

    const [carritoCitas, setCarritoCitas] = useState(() => {
        const storedCart = localStorage.getItem("carritoCitas");
        return storedCart ? JSON.parse(storedCart) : [];
    });

    const [carritoPedidos, setCarritoPedidos] = useState(() => {
        const storedOrders = localStorage.getItem("carritoPedidos");
        return storedOrders ? JSON.parse(storedOrders) : [];
    });

    useEffect(() => {
        localStorage.setItem("carritoCitas", JSON.stringify(carritoCitas));
    }, [carritoCitas]);

    useEffect(() => {
        localStorage.setItem("carritoPedidos", JSON.stringify(carritoPedidos));
    }, [carritoPedidos]);

    const setCerrarSesion = () => {
        setUsuario(null);
        setToken(null);
        setCarritoCitas([]);
        setCarritoPedidos([]);
        setInvernaderoSeleccionado(null);
        localStorage.removeItem("carritoCitas");
        localStorage.removeItem("carritoPedidos");
    };

    const setLogin = async (data) => {
        try {
            setUsuario(data.usuario);
            setToken(data.token);
        } catch (error) {
            console.log(error);
        }
    };

    const agregarProductoAlCarrito = (producto) => {
        setCarritoPedidos((prev) => {
            const existe = prev.find((item) => item.id === producto.id);
            if (existe) {
                return prev.map((item) =>
                    item.id === producto.id
                        ? { ...item, cantidad: (item.cantidad || 1) + 1 }
                        : item
                );
            }
            return [...prev, { ...producto, cantidad: 1 }];
        });
    };
    
    const agregarServicioAlCarrito = (servicio) => {
        setCarritoCitas((prev) => {
            const existe = prev.find((item) => item.id === servicio.id);
            if (existe) {
                return prev;
            }
            return [...prev, servicio];
        });
    };

    const vaciarCarritoCitas = () => {
        setCarritoCitas([]);
        localStorage.removeItem("carritoCitas");
    };

    const vaciarCarritoPedidos = () => {
        setCarritoPedidos([]);
        localStorage.removeItem("carritoPedidos");
    };

    return (
        <UsuarioContext.Provider
            value={{
                usuario,
                token,
                carritoPedidos,
                carritoCitas,
                invernaderoSeleccionado,
                setLogin,
                setCerrarSesion,
                setCarritoCitas,
                setCarritoPedidos,
                agregarProductoAlCarrito,
                agregarServicioAlCarrito,
                vaciarCarritoCitas,
                vaciarCarritoPedidos,
                setInvernaderoSeleccionado
            }}
        >
            {props.children}
        </UsuarioContext.Provider>
    );
};

export default UsuarioState;
